import omit from 'lodash/omit'

import { CityCount } from '@/components/Modal/Types/GeoFilter'
import { GeoFilter, QueryParams } from '@/types/filter'

import { parseGeoSlug } from './zone-slug-parser'

const geoFilterToSlug = (zoneFilter: string[] = [], zones: string[]): string[] =>
  zones.filter((zone) => zoneFilter.includes(parseGeoSlug(zone)))

const geoSlugToFilter = (slug: string): string | undefined =>
  slug.includes('/') ? slug.split('/').reverse()[0] : undefined

const formatFiltersForQuery = (filters: QueryParams, zones?: GeoFilter[]): QueryParams => {
  // Remove byZone because we must use byGeoSlug
  const filtersWithoutZone = omit(filters, 'byZone')

  return filters.byZone && zones
    ? {
        ...filtersWithoutZone,
        byGeoSlug: geoFilterToSlug(
          filters.byZone,
          zones.map((zone) => zone.slug)
        ),
      }
    : filtersWithoutZone
}

const formatRange = (min: string | number, max: string | number, t: (str: string) => string): string => {
  if (min && max) {
    return `${min} - ${max}`
  } else if (min) {
    return `${t('filter:from')} ${min}`
  } else if (max) {
    return `${t('filter:max')} ${max}`
  }
}

const buildZoneFilter = (filters: GeoFilter[]): { byZone: string[] } => ({
  byZone: filters.filter(Boolean).map((filter) => geoSlugToFilter(filter.slug)),
})

const buildCityFilter = (cities: CityCount[]): { byZone: string[] } => ({
  byZone: cities.filter(Boolean).map((city) => geoSlugToFilter(city.slug)),
})

const filtersMapperUtils = {
  buildCityFilter,
  buildZoneFilter,
  formatFiltersForQuery,
  formatRange,
  geoFilterToSlug,
  geoSlugToFilter,
}

export default filtersMapperUtils
